// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useContext, useState} from 'react';

import {RegistriesSearchContext} from '../common/RegistriesSearchContextProvider';

const RegistriesSearchBar = () => {
  const {searchFilter, setSearchFilter} = useContext(RegistriesSearchContext);
  const [searchBarText, setSearchBarText] = useState(searchFilter ?? '');

  return (
    <div className="font-base mt-24 flex w-full items-center gap-12">
      <TextField
        size="large"
        placeholder="Search for a registry, collection or version by name, tag or alias"
        value={searchBarText}
        autoFocus={true}
        onChange={(value: string) => setSearchBarText(value)}
        icon="search"
        onKeyDown={e => {
          if (e === 'Enter') {
            if (searchBarText.trim() === '') {
              setSearchFilter(undefined);
            } else {
              setSearchFilter(searchBarText);
            }
          }
        }}
        extraActions={
          searchBarText ? (
            <Button
              variant="ghost"
              icon="close"
              size="small"
              className="mr-4"
              onClick={() => {
                setSearchBarText('');
                setSearchFilter(undefined);
              }}
            />
          ) : undefined
        }
      />
    </div>
  );
};

export default RegistriesSearchBar;
